import { useQuery } from '@tanstack/react-query';
import { VisualizationRanksApi } from '@/lib/api/roadmapping/visualization-ranks';
import { roadmappingQueryKeys } from '@/lib/query-keys/roadmapping';

export const useVisualizationItemRanks = ({
  viewId,
  visualizationId,
  enabled = true,
}: {
  viewId: number;
  visualizationId: number;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: roadmappingQueryKeys.itemRanks.detail(viewId, visualizationId),
    queryFn: async () => {
      const entries = await VisualizationRanksApi.getItemRanks(viewId, visualizationId);
      const map = new Map<number, string>();
      for (const entry of entries) {
        map.set(entry.itemId, entry.rank);
      }
      return map;
    },
    enabled,
    refetchOnMount: false,
  });
};
